import React, { Component } from 'react';

import acceptWhiteImg from './../../statics/img/accept_white.png';

class simpleHeader extends Component {
    
    render(){
        return (
            <div className=" body heads">
                <div className="left_col acq_partner">
                    <div className="nav_title col-md-12 acq_partner">
                            {this.props.acq_partner?
                                <a className="navbar-brand" href={this.props.acq_partner_data.partner_redirect_url}>
                                    <img alt="Brand" src={this.props.acq_partner_data.partner_logo} width="180" />
                                </a>
                            :
                                <a className="navbar-brand" href="https://weaccept.co">
                                    <img alt="Brand" src={acceptWhiteImg} width="180" />
                                </a>
                            }
                    </div>


                    <div className="clearfix"></div>

                    <br />

                </div>
            </div>  
        );
    }

}

export default simpleHeader;
